module.exports = "/dist/3b9590e03f8940b592cce06bac81eaeb.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-900italic.woff
// module id = 166
// module chunks = 0